import { Box, Typography } from '@mui/material';

const DrawerFormPreview = ({
  title,
  subtitle,
  badge,
  children,
  footer,
  sx = {},
  bodySx = {},
}) => (
  <Box
    sx={{
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 1,
      backgroundColor: 'background.paper',
      overflow: 'hidden',
      minWidth: 0,
      ...sx,
    }}
  >
    {(title || subtitle || badge) && (
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: badge ? 'minmax(0, 1fr) auto' : '1fr' },
          gap: 1.5,
          alignItems: 'center',
          px: { xs: 1.5, md: 2 },
          py: 1.5,
          borderBottom: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.paper',
          minWidth: 0,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          {title && (
            <Typography
              variant="h6"
              sx={{
                color: 'primary.main',
                fontWeight: 800,
                lineHeight: 1.15,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              title={typeof title === 'string' ? title : undefined}
            >
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                fontWeight: 600,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              title={typeof subtitle === 'string' ? subtitle : undefined}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
        {badge && (
          <Box
            sx={{
              justifySelf: { xs: 'stretch', sm: 'end' },
              border: '1px solid',
              borderColor: 'primary.main',
              borderRadius: 1,
              px: 1.5,
              py: 0.75,
              minWidth: { xs: 0, sm: 150 },
              textAlign: { xs: 'left', sm: 'right' },
            }}
          >
            {badge}
          </Box>
        )}
      </Box>
    )}

    <Box
      sx={{
        p: { xs: 1.5, md: 2 },
        display: 'flex',
        flexDirection: 'column',
        gap: 1.25,
        minWidth: 0,
        ...bodySx,
      }}
    >
      {children}
    </Box>

    {footer && (
      <Box
        sx={{
          px: { xs: 1.5, md: 2 },
          py: 1.5,
          borderTop: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.paper',
        }}
      >
        {footer}
      </Box>
    )}
  </Box>
);

export default DrawerFormPreview;
